import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7008c08e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "fixed"
};
const _hoisted_3 = {
  key: 1,
  class: "fixed_bottom"
};
const _hoisted_4 = {
  key: 1,
  class: "fixed"
};
const _hoisted_5 = {
  class: "pop_box_easy"
};
const _hoisted_6 = {
  class: "title_center"
};
const _hoisted_7 = {
  class: "title_content"
};
const _hoisted_8 = {
  class: "shadow_button"
};
const _hoisted_9 = {
  class: "xieyizhezhao"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_circle_close = _resolveComponent("circle-close");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_popup_picture = _resolveComponent("popup-picture");
  const _component_popup_rich = _resolveComponent("popup-rich");
  const _component_popup_agreement = _resolveComponent("popup-agreement");
  const _component_popup_buttom = _resolveComponent("popup-buttom");
  const _component_popupFormTmpl = _resolveComponent("popupFormTmpl");
  const _component_popup_agreet_content = _resolveComponent("popup-agreet-content");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$props.popsetting.hasOwnProperty('diyPopup') || $props.popsetting.diyPopup ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.bool && $props.popsetting.popStyle == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives(_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args)),
    class: "fixed_close"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_circle_close)]),
    _: 1
  })], 512), [[_vShow, $props.popsetting.closeShow == '0']]), _createElementVNode("div", {
    class: "fixed_wh",
    style: _normalizeStyle({
      backgroundImage: 'url(' + $props.popsetting.bgImg + ')',
      'border-radius': $props.popsetting.boxRadius + 'px',
      'background-color': $props.popsetting.bgColor
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.popcontent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list",
      key: 'pop' + index
    }, [item.text == '图片' ? (_openBlock(), _createBlock(_component_popup_picture, {
      key: 0,
      onOpenWechat: $options.openWechat,
      content: item.setStyle
    }, null, 8, ["onOpenWechat", "content"])) : _createCommentVNode("", true), item.text == '富文本' ? (_openBlock(), _createBlock(_component_popup_rich, {
      key: 1,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text == '协议组件' ? (_openBlock(), _createBlock(_component_popup_agreement, {
      key: 2,
      content: item.setStyle,
      onPopxie: $options.popxie
    }, null, 8, ["content", "onPopxie"])) : _createCommentVNode("", true), item.text == '按钮' ? (_openBlock(), _createBlock(_component_popup_buttom, {
      key: 3,
      onOpenWechat: $options.openWechat,
      class: "absolu_bottom",
      content: item.setStyle,
      onJumpKf: _cache[1] || (_cache[1] = wechatKf => _ctx.$emit('jumpKf', wechatKf)),
      onJumpCustomerAcquisition: _cache[2] || (_cache[2] = content => _ctx.$emit('jumpCustomerAcquisition', content))
    }, null, 8, ["onOpenWechat", "content"])) : _createCommentVNode("", true), item.text == '表单组件' ? (_openBlock(), _createBlock(_component_popupFormTmpl, {
      key: 4,
      content: item.setStyle,
      tid: $props.tid,
      onOpenWechat: _cache[3] || (_cache[3] = (appletlink, appletUrl, wholeApplet, wholeAppletType) => _ctx.$emit('openWechat', appletlink, appletUrl, wholeApplet, wholeAppletType)),
      onJumpKf: _cache[4] || (_cache[4] = wechatKf => _ctx.$emit('jumpKf', wechatKf)),
      onJumpCustomerAcquisition: _cache[5] || (_cache[5] = content => _ctx.$emit('jumpCustomerAcquisition', content)),
      onCloseComPopup: _cache[6] || (_cache[6] = () => _ctx.$emit('closeComPopup'))
    }, null, 8, ["content", "tid"])) : _createCommentVNode("", true)]);
  }), 128))], 4)])) : _createCommentVNode("", true), $data.bool && $props.popsetting.popStyle == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives(_createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.close && $options.close(...args)),
    class: "fixed_close"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_circle_close)]),
    _: 1
  })], 512), [[_vShow, $props.popsetting.closeShow == '0']]), _createElementVNode("div", {
    class: "fixed_bottomwh",
    style: _normalizeStyle({
      backgroundImage: 'url(' + $props.popsetting.bgImg + ')',
      'border-top-left-radius': $props.popsetting.boxRadius + 'px',
      'border-top-right-radius': $props.popsetting.boxRadius + 'px',
      'background-color': $props.popsetting.bgColor
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.popcontent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list",
      key: 'pop' + index
    }, [item.text == '图片' ? (_openBlock(), _createBlock(_component_popup_picture, {
      key: 0,
      onOpenWechat: $options.openWechat,
      content: item.setStyle
    }, null, 8, ["onOpenWechat", "content"])) : _createCommentVNode("", true), item.text == '富文本' ? (_openBlock(), _createBlock(_component_popup_rich, {
      key: 1,
      content: item.setStyle
    }, null, 8, ["content"])) : _createCommentVNode("", true), item.text == '协议组件' ? (_openBlock(), _createBlock(_component_popup_agreement, {
      key: 2,
      content: item.setStyle,
      onPopxie: $options.popxie
    }, null, 8, ["content", "onPopxie"])) : _createCommentVNode("", true), item.text == '按钮' ? (_openBlock(), _createBlock(_component_popup_buttom, {
      key: 3,
      onOpenWechat: $options.openWechat,
      onClosetab: $options.close,
      onQure: $options.close,
      class: "absolu_bottom",
      content: item.setStyle
    }, null, 8, ["onOpenWechat", "onClosetab", "onQure", "content"])) : _createCommentVNode("", true)]);
  }), 128))], 4)])) : _createCommentVNode("", true)], 64)) : $data.bool ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString($props.popsetting.shadowTitle), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($props.popsetting.shadowContent), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
    class: "button",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.close && $options.close(...args))
  }, "取消"), _createElementVNode("span", {
    class: "button",
    style: _normalizeStyle({
      'color': $props.popsetting.buttonColor || '#000',
      'border-left': '1px solid #ddd'
    }),
    onClick: _cache[9] || (_cache[9] = (...args) => $options.handleEasyOk && $options.handleEasyOk(...args))
  }, _toDisplayString($props.popsetting.buttonText), 5)])])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    onClick: _cache[10] || (_cache[10] = (...args) => $options.close && $options.close(...args)),
    class: "zhezhao"
  }, null, 512), [[_vShow, $data.iszhezhao]]), _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [[_vShow, $data.isxieyi]]), $data.isxieyi ? (_openBlock(), _createBlock(_component_popup_agreet_content, {
    key: 2,
    content: $data.agreetContent,
    onCloseisxieyi: $options.closeisxieyi
  }, null, 8, ["content", "onCloseisxieyi"])) : _createCommentVNode("", true)]);
}